import { render, staticRenderFns } from "./GameRouteConfig.vue?vue&type=template&id=34637b13"
import script from "./GameRouteConfig.vue?vue&type=script&lang=js"
export * from "./GameRouteConfig.vue?vue&type=script&lang=js"
import style0 from "./GameRouteConfig.vue?vue&type=style&index=0&id=34637b13&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports